// @flow
import * as React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import type { Opponent, Team } from "../../common/types";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import TeamLogo from "../../components/TeamLogo";

type Props = {
  leftTeam: Team | Opponent,
  rightTeam: Team | Opponent,
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      // borderRadius: 6,
      // backgroundColor: "rgba(0,0,0,0.5)",
      padding: theme.spacing(2),
    },
  })
);

function GameDetailsHeader({ leftTeam, rightTeam }: Props) {
  const classes = useStyles();

  return (
    <Box className={classes.wrapper}>
      <Grid container spacing={2}>
        <Grid item xs={5}>
          <TeamLogo
            iconString={leftTeam.iconString}
            name={leftTeam.name}
            width="100%"
            height={90}
          />
          <Box mt={1}>
            <Typography
              align="center"
              variant="body2"
              component="div"
              color="textSecondary"
            >
              {leftTeam.name}
            </Typography>
          </Box>
        </Grid>
        <Grid item container xs={2} justify="center" alignItems="center">
          <Typography variant="h5" component="div">
            <b>VS</b>
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <TeamLogo
            iconString={rightTeam.iconString}
            name={rightTeam.name}
            width="100%"
            height={90}
          />
          <Box mt={1}>
            <Typography
              align="center"
              variant="body2"
              component="div"
              color="textSecondary"
            >
              {rightTeam.name}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export default GameDetailsHeader;
